import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import bemNames from '../../generalUtils/benames';
import CustomCard from './CustomCard';
import { NODATAFOUND } from '../../constants/messageConst';

const bem = bemNames.create('collapseCard');

/** ----PROPERTY----
  <CollapseComponent
    id=""
    title=""
    isOpen={false}
    addedClass=''
    addedCardTitleClass=''
    rightTitle=''
    titleClassName=''
    addedCardBodyClass=''
    addedChildClass==''
    cardDataLoaded={true}
    cardBodyHeight={10}  // in rem,
    onCollapseChange  // Event for check Collapse Open Or Close,
    onClick
  >
    {children}
  </CollapseComponent>
*/

const CollapseComponent = props => {
  const {
    id,
    title,
    isOpen,
    addedClass,
    addedCardTitleClass,
    titleClassName,
    addedCardBodyClass,
    addedChildClass,
    cardDataLoaded,
    cardBodyHeight,
    onClick,
    onCollapseChange,
    children,
    addedTitleRenderElement,
    rightTitle = '',
    addedSmallTitleRenderElement,
    collapseStyle = '',
    addedTitleRenderElementClass = '',
    isUnderConstuction = false,
    smalltitle
  } = props;
  const [open, setOpen] = useState(false);
  const [contentVisible, setContentVisible] = useState(false);
  const [cardbodyMaxHeight, setCardbodyMaxHeight] = useState(cardBodyHeight);

  const DEFAULT_MAX_HEIGHT = 100;

  const setProperty = isInitial => {
    let isOpened = isInitial ? isOpen || false : !open;
    setOpen(isOpened);
    if ((isOpened && cardBodyHeight) || (!isOpened && !cardBodyHeight)) {
      setContentVisible(isOpened);
    } else {
      setTimeout(() => {
        setContentVisible(isOpened);
      }, 400);
    }

    if (onCollapseChange) {
      onCollapseChange({ isOpen: isOpened });
    }

    if (isOpened) {
      setCardbodyMaxHeight(cardBodyHeight || DEFAULT_MAX_HEIGHT);
    } else {
      setCardbodyMaxHeight(0);
    }
  };

  useEffect(() => {
    setProperty(true);
  }, [isOpen]);

  return (
    <CustomCard
      title={title}
      id={id}
      smalltitle={smalltitle}
      addedClass={`mb-3 p-0 ${bem.b(`${addedClass}`)} ${
        collapseStyle == 'line-bottom' ? bem.m('line-bottom') : ''
      } ${open ? 'expand-collapse' : ''}`}
      addedCardTitleClass={`${addedCardTitleClass} p-3 ${open ? 'expanded' : ''}`}
      titleClassName={`${titleClassName}`}
      addedCardBodyClass={`${addedCardBodyClass} collapse-body ${
        (contentVisible && open) || (contentVisible && cardBodyHeight)
          ? cardBodyHeight
            ? 'overflow-y-scroll'
            : 'overflow-visible'
          : 'overflow-hidden'
      } ${open ? 'expanded' : ''}`}
      cardbodyMaxHeight={cardbodyMaxHeight}
      isCardLoading={!cardDataLoaded}
      onClick={onClick}
      onTitleClick={() => setProperty()}
      titleRenderElement={
        <div className={addedTitleRenderElementClass}>
          {addedTitleRenderElement}
          <div>
            {rightTitle}
            <i className={`fa ${open ? 'fa-minus' : 'fa-plus'}`} />
          </div>
        </div>
      }
      smallTitleRenderElement={addedSmallTitleRenderElement}
      isUnderConstuction={isUnderConstuction}
    >
      {children ? (
        <div className={`p-8 ${addedChildClass}`}>{children}</div>
      ) : (
        <div className={`text-danger`}>
          <i className="fa fa-fw fa-exclamation" aria-hidden="true" /> {NODATAFOUND}
        </div>
      )}
    </CustomCard>
  );
};

CollapseComponent.propTypes = {
  id: PropTypes.any,
  title: PropTypes.any,
  smalltitle: PropTypes.any,
  isOpen: PropTypes.bool,
  addedClass: PropTypes.any,
  addedCardTitleClass: PropTypes.any,
  titleClassName: PropTypes.any,
  addedCardBodyClass: PropTypes.any,
  addedChildClass: PropTypes.any,
  cardDataLoaded: PropTypes.bool,
  cardBodyHeight: PropTypes.number,
  onClick: PropTypes.func,
  onCollapseChange: PropTypes.func,
  addedTitleRenderElement: PropTypes.any,
  addedSmallTitleRenderElement: PropTypes.any,
  children: PropTypes.any,
  addedTitleRenderElementClass: PropTypes.any,
  collapseStyle: PropTypes.any
};

CollapseComponent.defaultProps = {
  title: '',
  isOpen: false,
  addedClass: '',
  addedCardTitleClass: '',
  titleClassName: '',
  addedCardBodyClass: '',
  addedChildClass: '',
  cardDataLoaded: false,
  cardBodyHeight: null,
  onClick: null,
  onCollapseChange: null,
  addedTitleRenderElement: null,
  addedSmallTitleRenderElement: null,
  addedTitleRenderElementClass: '',
  collapseStyle: ''
};

export default React.memo(CollapseComponent);
